import { type FC, memo, useMemo } from 'react';

import type { Props } from '@/components/select/WorkGroupSelect/types';
import useAPI from '@/hooks/useAPI';
import WorkRepository from '@/repositories/WorkRepository';
import AutocompleteSingleSelect from '@/ui/components/AutocompleteSingleSelect';
import Spinner from '@/ui/components/Spinner';

const WorkGroupSelect: FC<Props> = ({
  disabled = false,
  label,
  onChange,
  placeholder = 'Select workGroup',
  selectedOption
}) => {
  const workRepository = WorkRepository();

  const { data, isPending } = useAPI({
    queryKey: ['getWorkGroups'],
    queryFn: async () => {
      return await workRepository.getWorkGroups();
    }
  });

  const workGroupOptions = useMemo(() => {
    return (
      data?.data?.results?.map((workGroup) => {
        return {
          label: workGroup.name,
          value: workGroup.id
        };
      }) ?? []
    );
  }, [data?.data]);

  return isPending ? (
    <Spinner label="Loading work groups" />
  ) : (
    <AutocompleteSingleSelect
      disabled={disabled}
      label={label}
      onChange={onChange}
      options={workGroupOptions}
      placeholder={placeholder}
      selectedOption={selectedOption}
    />
  );
};

export default memo(WorkGroupSelect);
